export const SCHEDULING_LINK_MODAL_ID = "scheduling_link_modal";

/**
 * Backend `error_code` returned (with HTTP 403) when the AE's calendar OAuth
 * grant is missing the `calendars:read` scope. Detection can't proceed, so
 * callers stop retrying rather than hammering the endpoint.
 */
export const INSUFFICIENT_OAUTH_SCOPES_ERROR_CODE = 1180;
